import { toggleClass, findParent } from "@src/utils/dom";
import "./index.css";
import { toggleScrollFixed } from "@src/utils/globalScrollHelper";
import updateShortlistCount from "./shortlist";

const LIST = "container-header-language-list";
const LIST_ACTIVE = "container-header-language-list__active";
const LANG_BTN = "container-header-language-button";
const MENU = "container-header-menu";
const NAV = "container-header-nav";
const NAV_BG = "container-header-nav-bg";
const NAV_ACTIVE = "container-header-nav__active";
const NAV_CLOSE = "container-header-nav-close";

export function setupHeader() {
  updateShortlistCount();

  function closeAllLanguageDropdowns() {
    document.querySelectorAll<HTMLElement>(`.${LIST_ACTIVE}`).forEach((el) => {
      el.classList.remove(LIST_ACTIVE);
    });
  }

  function getDropdownForButton(btn: HTMLElement): HTMLElement | null {
    return btn.parentElement?.querySelector<HTMLElement>(`.${LIST}`) ?? null;
  }

  document.querySelectorAll<HTMLElement>(`.${LANG_BTN}`).forEach((btn) => {
    btn.addEventListener("click", function (this: HTMLElement, e: Event) {
      e.stopPropagation();
      const list = getDropdownForButton(this);
      if (!list) return;
      const isOpen = list.classList.contains(LIST_ACTIVE);
      closeAllLanguageDropdowns();
      if (!isOpen) list.classList.add(LIST_ACTIVE);
    });
  });

  // click outside — close any open language dropdown
  document.addEventListener("click", function (e) {
    if (!findParent(e.target as HTMLElement, LIST)) {
      closeAllLanguageDropdowns();
    }
  });

  // show menu
  document
    .querySelector(`.${MENU}`)
    ?.addEventListener("click", function (this: HTMLElement, e: Event) {
      e.stopPropagation();
      const nav = document.querySelector(`.${NAV}`) as HTMLElement;
      toggleClass(nav, NAV_ACTIVE);
      toggleScrollFixed(true);
    });

  // close & empty  close menu
  document
    .querySelector(`.${NAV}`)
    ?.addEventListener("click", function (this: HTMLElement, e: Event) {
      const sourceEle = e.target as HTMLElement;
      if (!this.classList.contains(NAV_ACTIVE)) return;
      if (
        sourceEle.classList.contains(NAV_CLOSE) ||
        !findParent(sourceEle, NAV_BG)
      ) {
        this.classList.remove(NAV_ACTIVE);
        toggleScrollFixed(false);
      }
    });
}
